module.exports = __webpack_public_path__ + "img/stock7.79a68e1d.png";